/* eslint-disable max-len */

import React from 'react'
import { FormattedMessage } from 'react-intl'

export const DESCRIPTION_SUBTITLE = (
    <FormattedMessage
        id='battle_title_tooltip.description_subtitle'
        defaultMessage='Описание режима'
    />
)

export const REWARD_SUBTITLE = (
    <FormattedMessage
        id='battle_title_tooltip.reward_subtitle'
        defaultMessage='Награда'
    />
)

export const FORT_BATTLE_CONTENTS = {
    definition: (
        <FormattedMessage
            id='battle_title_tooltip.fort_battle.definition'
            defaultMessage='Серия боёв в течение часа или меньше за промресурс на плацдармах Укрепрайонов противостоящих кланов.'
        />
    ),
    description: [
        <FormattedMessage
            key='battle_title_tooltip.fort_battle.description_item1'
            id='battle_title_tooltip.fort_battle.description_item1'
            defaultMessage='Кланы формируют отряды и ожидают начала Наступления. Противник подбирается случайным образом.'
        />,
        <FormattedMessage
            key='battle_title_tooltip.fort_battle.description_item2'
            id='battle_title_tooltip.fort_battle.description_item2'
            defaultMessage='Наступление начинается с боя на нейтральной территории (случайная карта). Победитель будет атаковать рубеж противника.'
        />,
        <FormattedMessage
            key='battle_title_tooltip.fort_battle.description_item3'
            id='battle_title_tooltip.fort_battle.description_item3'
            defaultMessage='Следующие бои проходят за рубежи кланов.'
        />,
        <FormattedMessage
            key='battle_title_tooltip.fort_battle.description_item4'
            id='battle_title_tooltip.fort_battle.description_item4'
            defaultMessage='Наступление завершится либо захватом Цитадели противника, либо по истечении отведённого времени.'
        />,
    ],
    reward: (
        <FormattedMessage
            id='battle_title_tooltip.fort_battle.reward'
            defaultMessage='Клан получает награду за количество контролируемых им рубежей по итогам Наступления. Чем больше рубежей под контролем клана, тем выше награда. Кроме того, клан получает промресурс за каждый бой в ходе Наступления.'
        />
    ),
}

export const SORTIE_CONTENTS = {
    definition: (
        <FormattedMessage
            id='battle_title_tooltip.sortie.definition'
            defaultMessage='Бой между кланами за промресурс на нейтральной территории.'
        />
    ),
    description: (
        <FormattedMessage
            id='battle_title_tooltip.sortie.description'
            defaultMessage='Клан собирает отряд и подтверждает готовность, после чего автоматически подбирается противник. Бой происходит на случайной карте.'
        />
    ),
    reward: (
        <FormattedMessage
            id='battle_title_tooltip.sortie.reward'
            defaultMessage='Трофейный промресурс разделяется между кланами. Победитель получает основную долю награды.'
        />
    ),
}



// WEBPACK FOOTER //
// ./components/BattleWizard/components/BattleTitleTooltip/constants.jsx